import { type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import { lineDeformOptionsState } from '~/state/atoms/toolsAtoms';
import ToolTraySlider from './ToolTraySlider';

const MIN_SPREAD_PERCENT = 1;
const MAX_SPREAD_PERCENT = 100;

interface LineDeformToolOptionsProps {
    /** Switches shown before the spread. */
    children?: ReactNode;
}

export default function LineDeformToolOptions({
    children,
}: LineDeformToolOptionsProps) {
    const intl = useIntl();
    const [deformOptions, setDeformOptions] = useRecoilState(
        lineDeformOptionsState
    );

    const handleSetSpread = (percent: number) => {
        if (percent < MIN_SPREAD_PERCENT || percent > MAX_SPREAD_PERCENT) {
            return;
        }
        setDeformOptions((options) => ({
            ...options,
            spreadPercent: percent,
        }));
    };

    return (
        <>
            {children}
            <ToolTraySlider
                label={intl.formatMessage({ id: 'toolOptions.contour' })}
                value={deformOptions.spreadPercent}
                onChange={handleSetSpread}
                step={1}
                min={MIN_SPREAD_PERCENT}
                max={MAX_SPREAD_PERCENT}
                valueText={`${deformOptions.spreadPercent}`}
                unit="%"
            />
        </>
    );
}
